import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./login/login').then((m) => m.Login),
  },
  {
    path: '',
    loadComponent: () => import('./layout/layout').then((m) => m.Layout),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'esign',
        loadChildren: () =>
          import('./esign/esign.routes').then((m) => m.ESIGN_ROUTES),
      },
      {
        path: 'members',
        loadChildren: () =>
          import('./members/members.routes').then((m) => m.MEMBERS_ROUTES),
      },
      {
        path: 'organic',
        loadChildren: () =>
          import('./organic/organic.routes').then((m) => m.ORGANIC_ROUTES),
      },
      {
        path: 'marketing',
        loadChildren: () =>
          import('./marketing/marketing.routes').then((m) => m.MARKETING_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: 'dashboard' },
];
